var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.className,
    _vm.themeClassName,
    _vm.textAlignClassName,
    _vm.textSizeClassName
  ],style:(_vm.styleObject),attrs:{"data-test":"gc__copy"},domProps:{"innerHTML":_vm._s(_vm.markdownify(_vm.content))}})}
var staticRenderFns = []

export { render, staticRenderFns }